import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { getLenis } from '../lib/lenis';
import PageTransition from './PageTransition';
import Home from '../pages/Home';
import ProjectsPage from '../pages/ProjectsPage';
import ProjectDetail from '../pages/ProjectDetail';
import Error404 from '../components/Error404';

const AnimatedRoutes = () => {
  const location = useLocation();

  const resetScroll = () => {
    const lenis = getLenis();
    if (lenis) lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  };

  return (
    <AnimatePresence mode="wait" initial={false} onExitComplete={resetScroll}>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<PageTransition><Home /></PageTransition>} />
        <Route path="/projects" element={<PageTransition><ProjectsPage /></PageTransition>} />
        <Route path="/project/:slug" element={<PageTransition><ProjectDetail /></PageTransition>} />
        <Route path="*" element={<PageTransition><Error404 /></PageTransition>} />
      </Routes>
    </AnimatePresence>
  );
};

export default AnimatedRoutes;
